export const LANGUAGES = [
  { code: "en", label: "EN" },
  { code: "es", label: "ES" },
  { code: "fr", label: "FR" },
];

export const translations = {
  en: {
    nav: { work: "Work", services: "Services", process: "Process", pricing: "Pricing", contact: "Contact", quote: "Get a Quote" },
    hero: {
      badge: "Boutique Creative Studio",
      titleLines: ["Websites,", "Film", "and Photography", "for Growing Brands."],
      subtitle: "We build the site, shoot the film and make the photographs — one studio, one look, so your brand feels like a single idea everywhere it shows up.",
      explore: "Explore Website Demos",
      quote: "Get a Quote",
    },
    portfolio: {
      heading: ["Featured", "Demos."],
      intro: "Three living concepts, fully clickable. Step inside each world and feel how the right design converts.",
      view: "View live demo",
    },
    demos: {
      "sora-sushi": { tag: "Hospitality / Luxury", blurb: "A dark, editorial omakase experience with full-screen visuals and reservation-first design." },
      "verdant-landscapes": { tag: "Local Services / Outdoor", blurb: "Earth-toned, vibrant imagery with an instant quote calculator and a living project gallery." },
      "sparkle-shine": { tag: "Service / Residential", blurb: "Fresh, bright and airy with instant booking, trust badges and glowing customer reviews." },
    },
    services: {
      label: "What we do",
      heading: ["A brand that works", "everywhere."],
      items: [
        { title: "Websites That Convert", desc: "Fast, custom, built to rank. Optional AI chatbot and 24/7 receptionist." },
        { title: "Video & Social Content", desc: "One shoot. A hero film, plus a month of cutdowns." },
        { title: "Brand Photography", desc: "Your space, your product, your people." },
      ],
    },
    process: {
      heading: ["How we", "work."],
      steps: [
        { title: "Discovery & Strategy", desc: "We dig into your brand, audience and goals — mapping the exact journey that turns a visitor into a client before a single pixel is drawn." },
        { title: "Design & Prototype", desc: "Editorial, considered design brought to life in interactive prototypes. You see, feel and refine the experience long before launch." },
        { title: "Launch & Scale", desc: "A blazing-fast build ships to the world, then we measure, optimize and grow — treating your site as a living asset, not a one-off." },
      ],
    },
    pricing: {
      label: "Investment",
      heading: ["Everything your launch", "needs, in one build."],
      buildTag: "The Launch Package · Everything included",
      buildDesc: "Website, launch film and a full photo library — produced together, so the brand reads as one thing instead of three vendors who never spoke.",
      buildCta: "Start My Launch",
      includes: ["Custom website, designed & built", "1 hero video + 5 social cutdowns", "20–30 retouched brand photos", "Multilingual site setup", "Live chat setup", "1-month post-launch support"],
      alaCarteLabel: "Or book any piece on its own",
      alaCarte: [
        { name: "Website Build", tagline: "A complete custom site — designed, built and launched.", note: "Ask about adding an AI chatbot & 24/7 receptionist" },
        { name: "Signature Content", tagline: "One hero video (45–75s) plus five short cutdowns, shot in a single session." },
        { name: "Brand Photography", tagline: "20–30 retouched images — your space, product, team and ambiance." },
      ],
      ownershipTitle: "It's 100% yours.",
      ownershipBody: "Domain, hosting, code, footage and photos — all in your name from day one. You keep the logins and the raw files.",
      supportTitle: "Support, not a leash.",
      supportBody: "First month included while you settle in. After that nothing breaks and nothing expires — need a change, just ask.",
    },
    contact: {
      heading: ["Let's build", "something rare."],
      intro: "Tell us about your brand. Friction-free — a few details and we'll craft a tailored proposal for you.",
      name: "Name", email: "Email", business: "Business Name", servicesNeeded: "Services Needed", projectDetails: "Project Details",
      submit: "Send Inquiry", sending: "Sending…",
      stillSending: "Still working — our server may be waking up. This can take up to a minute.",
      phName: "Jane Doe", phBusiness: "Your company", phServices: "e.g. New website", phDetails: "Tell us a little about your project…",
      toastMissing: "Please add your name and email.",
      toastSuccess: "Inquiry sent — we'll be in touch within one business day.",
      toastError: "Something went wrong. Please try again.",
    },
    footer: {
      tagline: "A boutique creative studio making websites, film and photography for growing brands.",
      explore: "Explore", social: "Social", rights: "All rights reserved.",
    },
  },

  es: {
    nav: { work: "Trabajo", services: "Servicios", process: "Proceso", pricing: "Precios", contact: "Contacto", quote: "Solicitar presupuesto" },
    hero: {
      badge: "Estudio creativo boutique",
      titleLines: ["Webs,", "vídeo", "y fotografía", "para marcas en crecimiento."],
      subtitle: "Construimos la web, grabamos el vídeo y hacemos las fotos — un solo estudio, una sola mirada, para que tu marca se sienta como una única idea en todas partes.",
      explore: "Ver demos de webs",
      quote: "Solicitar presupuesto",
    },
    portfolio: {
      heading: ["Demos", "destacadas."],
      intro: "Tres conceptos reales, totalmente navegables. Entra en cada mundo y siente cómo convierte el buen diseño.",
      view: "Ver demo en vivo",
    },
    demos: {
      "sora-sushi": { tag: "Hostelería / Lujo", blurb: "Una experiencia omakase oscura y editorial, con imágenes a pantalla completa y diseño centrado en la reserva." },
      "verdant-landscapes": { tag: "Servicios locales / Exteriores", blurb: "Tonos tierra e imágenes vibrantes, con calculadora de presupuesto instantáneo y galería de proyectos." },
      "sparkle-shine": { tag: "Servicio / Residencial", blurb: "Fresco, luminoso y ligero, con reserva instantánea, sellos de confianza y reseñas de clientes." },
    },
    services: {
      label: "Qué hacemos",
      heading: ["Una marca que funciona", "en todas partes."],
      items: [
        { title: "Webs que convierten", desc: "Rápidas, a medida, listas para posicionar. Chatbot de IA y recepción 24/7 opcionales." },
        { title: "Vídeo y contenido social", desc: "Una sesión. Un vídeo y un mes de clips." },
        { title: "Fotografía de marca", desc: "Tu espacio, tu producto, tu equipo." },
      ],
    },
    process: {
      heading: ["Cómo", "trabajamos."],
      steps: [
        { title: "Descubrimiento y estrategia", desc: "Analizamos tu marca, tu público y tus objetivos — trazando el recorrido exacto que convierte a un visitante en cliente antes de dibujar un solo píxel." },
        { title: "Diseño y prototipo", desc: "Diseño editorial y cuidado, hecho realidad en prototipos interactivos. Ves, sientes y perfeccionas la experiencia mucho antes del lanzamiento." },
        { title: "Lanzamiento y crecimiento", desc: "Un sitio ultrarrápido sale al mundo; luego medimos, optimizamos y hacemos crecer — tratando tu sitio como un activo vivo, no como algo de una sola vez." },
      ],
    },
    pricing: {
      label: "Inversión",
      heading: ["Todo lo que necesita tu lanzamiento,", "en un solo proyecto."],
      buildTag: "El Paquete de Lanzamiento · Todo incluido",
      buildDesc: "Web, vídeo de lanzamiento y una biblioteca completa de fotos — producidos juntos, para que la marca se sienta como una sola cosa y no como tres proveedores que nunca hablaron entre sí.",
      buildCta: "Empezar mi lanzamiento",
      includes: ["Web a medida, diseñada y construida", "1 vídeo principal + 5 clips sociales", "20–30 fotos de marca retocadas", "Configuración multilingüe", "Configuración de chat en vivo", "1 mes de soporte tras el lanzamiento"],
      alaCarteLabel: "O contrata cada pieza por separado",
      alaCarte: [
        { name: "Desarrollo web", tagline: "Un sitio completo a medida — diseñado, construido y lanzado.", note: "Pregúntanos por añadir un chatbot con IA y recepción 24/7" },
        { name: "Contenido Signature", tagline: "Un vídeo principal (45–75s) más cinco clips cortos, grabados en una sola sesión." },
        { name: "Fotografía de marca", tagline: "20–30 imágenes retocadas — tu espacio, producto, equipo y ambiente." },
      ],
      ownershipTitle: "Es 100% tuyo.",
      ownershipBody: "Dominio, alojamiento, código, grabaciones y fotos — todo a tu nombre desde el primer día. Tuyos los accesos y los originales.",
      supportTitle: "Soporte, no una atadura.",
      supportBody: "Primer mes incluido mientras te acomodas. Después nada se rompe ni caduca — si necesitas un cambio, nos escribes.",
    },
    contact: {
      heading: ["Creemos algo", "excepcional."],
      intro: "Cuéntanos sobre tu marca. Sin complicaciones — unos pocos datos y te prepararemos una propuesta a medida.",
      name: "Nombre", email: "Email", business: "Nombre de la empresa", servicesNeeded: "Servicios que necesitas", projectDetails: "Detalles del proyecto",
      submit: "Enviar consulta", sending: "Enviando…",
      stillSending: "Seguimos trabajando — puede que el servidor esté despertando. Esto puede tardar hasta un minuto.",
      phName: "Ana García", phBusiness: "Tu empresa", phServices: "p. ej. Nuevo sitio web", phDetails: "Cuéntanos un poco sobre tu proyecto…",
      toastMissing: "Añade tu nombre y tu email.",
      toastSuccess: "Consulta enviada — te responderemos en un día hábil.",
      toastError: "Algo salió mal. Inténtalo de nuevo.",
    },
    footer: {
      tagline: "Un estudio creativo boutique que crea webs, vídeo y fotografía para marcas en crecimiento.",
      explore: "Explorar", social: "Redes", rights: "Todos los derechos reservados.",
    },
  },

  fr: {
    nav: { work: "Réalisations", services: "Services", process: "Processus", pricing: "Tarifs", contact: "Contact", quote: "Demander un devis" },
    hero: {
      badge: "Studio créatif boutique",
      titleLines: ["Sites web,", "film", "et photographie", "pour marques en croissance."],
      subtitle: "Nous construisons le site, tournons le film et réalisons les photographies — un seul studio, un seul regard, pour que votre marque forme une idée unique partout où elle apparaît.",
      explore: "Voir les démos de sites",
      quote: "Demander un devis",
    },
    portfolio: {
      heading: ["Démos", "à la une."],
      intro: "Trois concepts vivants, entièrement cliquables. Entrez dans chaque univers et voyez comment un bon design convertit.",
      view: "Voir la démo",
    },
    demos: {
      "sora-sushi": { tag: "Hôtellerie / Luxe", blurb: "Une expérience omakase sombre et éditoriale, en plein écran, pensée avant tout pour la réservation." },
      "verdant-landscapes": { tag: "Services locaux / Extérieur", blurb: "Tons terreux et images vibrantes, avec un calculateur de devis instantané et une galerie de projets." },
      "sparkle-shine": { tag: "Service / Résidentiel", blurb: "Frais, lumineux et aéré, avec réservation instantanée, badges de confiance et avis clients élogieux." },
    },
    services: {
      label: "Ce que nous faisons",
      heading: ["Une marque qui fonctionne", "partout."],
      items: [
        { title: "Des sites qui convertissent", desc: "Rapides, sur mesure, pensés pour le référencement. Chatbot IA et accueil 24/7 en option." },
        { title: "Vidéo & contenu social", desc: "Une séance. Un film, plus un mois de formats courts." },
        { title: "Photographie de marque", desc: "Votre lieu, vos produits, votre équipe." },
      ],
    },
    process: {
      heading: ["Notre", "méthode."],
      steps: [
        { title: "Découverte & stratégie", desc: "Nous explorons votre marque, votre audience et vos objectifs — en traçant le parcours exact qui transforme un visiteur en client avant le moindre pixel." },
        { title: "Design & prototype", desc: "Un design éditorial et réfléchi, donné vie dans des prototypes interactifs. Vous voyez, ressentez et affinez l'expérience bien avant le lancement." },
        { title: "Lancement & croissance", desc: "Un site ultra-rapide est mis en ligne, puis nous mesurons, optimisons et faisons croître — en traitant votre site comme un actif vivant, pas un projet unique." },
      ],
    },
    pricing: {
      label: "Investissement",
      heading: ["Tout ce qu'il faut pour votre lancement,", "en un seul pack."],
      buildTag: "Le Pack Lancement · Tout compris",
      buildDesc: "Site web, film de lancement et une photothèque complète — produits ensemble, pour que la marque forme un tout au lieu de trois prestataires qui ne se sont jamais parlé.",
      buildCta: "Lancer mon projet",
      includes: ["Site sur mesure, conçu & développé", "1 film principal + 5 formats courts", "20–30 photos de marque retouchées", "Configuration multilingue", "Mise en place du chat en direct", "1 mois de support après lancement"],
      alaCarteLabel: "Ou réservez chaque prestation séparément",
      alaCarte: [
        { name: "Création de site", tagline: "Un site complet sur mesure — conçu, développé et lancé.", note: "Demandez-nous d'ajouter un chatbot IA et un accueil 24/7" },
        { name: "Contenu Signature", tagline: "Un film principal (45–75s) et cinq formats courts, tournés en une séance." },
        { name: "Photographie de marque", tagline: "20–30 images retouchées — votre lieu, vos produits, votre équipe et l'ambiance." },
      ],
      ownershipTitle: "C'est 100% à vous.",
      ownershipBody: "Domaine, hébergement, code, rushes et photos — à votre nom dès le premier jour. Vous gardez les accès et les sources.",
      supportTitle: "Un support, pas une laisse.",
      supportBody: "Premier mois inclus, le temps de prendre vos marques. Ensuite rien ne casse ni n'expire — une modification, vous demandez.",
    },
    contact: {
      heading: ["Créons quelque chose", "de rare."],
      intro: "Parlez-nous de votre marque. Sans friction — quelques informations et nous vous préparons une proposition sur mesure.",
      name: "Nom", email: "Email", business: "Nom de l'entreprise", servicesNeeded: "Services souhaités", projectDetails: "Détails du projet",
      submit: "Envoyer la demande", sending: "Envoi…",
      stillSending: "Toujours en cours — notre serveur se réveille peut-être. Cela peut prendre jusqu'à une minute.",
      phName: "Camille Martin", phBusiness: "Votre entreprise", phServices: "ex. Nouveau site web", phDetails: "Parlez-nous un peu de votre projet…",
      toastMissing: "Ajoutez votre nom et votre email.",
      toastSuccess: "Demande envoyée — nous vous répondrons sous un jour ouvré.",
      toastError: "Une erreur s'est produite. Veuillez réessayer.",
    },
    footer: {
      tagline: "Un studio créatif boutique qui réalise sites web, film et photographie pour les marques en croissance.",
      explore: "Explorer", social: "Réseaux", rights: "Tous droits réservés.",
    },
  },
};
